module.exports = __webpack_public_path__ + "img/antes_despues_339.f6a5df8d.png";